var map = {
	"./WidgetBase": 319,
	"./WidgetBase.jsx": 319,
	"./WidgetBase.module.scss": 204,
	"./WidgetFactory": 345,
	"./WidgetFactory.jsx": 345,
	"./WidgetGrid": 230,
	"./WidgetGrid.jsx": 230,
	"./logic/BosFileTransfer": 149,
	"./logic/BosFileTransfer.js": 149,
	"./logic/Constants": 59,
	"./logic/Constants.js": 59,
	"./logic/DateTimeUtils": 161,
	"./logic/DateTimeUtils.js": 161,
	"./logic/NumberUtils": 506,
	"./logic/NumberUtils.js": 506,
	"./logic/WidgetUtils": 79,
	"./logic/WidgetUtils.js": 79,
	"./widgets/ActionWidget": 507,
	"./widgets/ActionWidget.jsx": 507,
	"./widgets/ActionWidget.module.scss": 357,
	"./widgets/AmpelWidget": 508,
	"./widgets/AmpelWidget.jsx": 508,
	"./widgets/AttributePathWidget": 509,
	"./widgets/AttributePathWidget.jsx": 509,
	"./widgets/BosIconSelectorWidget": 511,
	"./widgets/BosIconSelectorWidget.jsx": 511,
	"./widgets/BosIconSelectorWidget.module.scss": 334,
	"./widgets/Checkbox2StatesWidget": 512,
	"./widgets/Checkbox2StatesWidget.jsx": 512,
	"./widgets/Checkbox2StatesWidget.module.scss": 403,
	"./widgets/Checkbox3StatesWidget": 513,
	"./widgets/Checkbox3StatesWidget.jsx": 513,
	"./widgets/Checkbox3StatesWidget.module.scss": 404,
	"./widgets/CheckgroupWidget": 514,
	"./widgets/CheckgroupWidget.jsx": 514,
	"./widgets/CheckgroupWidget.module.scss": 450,
	"./widgets/CodeWidget": 515,
	"./widgets/CodeWidget.jsx": 515,
	"./widgets/DMSWidget": 516,
	"./widgets/DMSWidget.jsx": 516,
	"./widgets/DMSWidget.module.scss": 335,
	"./widgets/DateTimeWidget": 517,
	"./widgets/DateTimeWidget.jsx": 517,
	"./widgets/DateTimeWidget.module.scss": 451,
	"./widgets/DateWidget": 518,
	"./widgets/DateWidget.jsx": 518,
	"./widgets/DateWidget.module.scss": 452,
	"./widgets/DecisionsWidget": 519,
	"./widgets/DecisionsWidget.jsx": 519,
	"./widgets/DecisionsWidget.module.scss": 453,
	"./widgets/DialogResultWidget": 520,
	"./widgets/DialogResultWidget.jsx": 520,
	"./widgets/DialogResultWidget.module.scss": 405,
	"./widgets/DropdownWidget": 521,
	"./widgets/DropdownWidget.jsx": 521,
	"./widgets/DropdownWidget.module.scss": 406,
	"./widgets/EmailWidget": 522,
	"./widgets/EmailWidget.jsx": 522,
	"./widgets/EmbeddedFormWidget": 523,
	"./widgets/EmbeddedFormWidget.jsx": 523,
	"./widgets/EmbeddedFormWidget.module.scss": 249,
	"./widgets/EmbeddedHtmlWidget": 524,
	"./widgets/EmbeddedHtmlWidget.jsx": 524,
	"./widgets/EmptyWidget": 525,
	"./widgets/EmptyWidget.jsx": 525,
	"./widgets/EntityPickerWidget": 526,
	"./widgets/EntityPickerWidget.jsx": 526,
	"./widgets/EntityPickerWidget.module.scss": 408,
	"./widgets/ErrorWidget": 527,
	"./widgets/ErrorWidget.jsx": 527,
	"./widgets/ExpressionWidget": 528,
	"./widgets/ExpressionWidget.jsx": 528,
	"./widgets/FilePathWidget": 529,
	"./widgets/FilePathWidget.jsx": 529,
	"./widgets/FolderWidget": 530,
	"./widgets/FolderWidget.jsx": 530,
	"./widgets/GridWidget": 531,
	"./widgets/GridWidget.jsx": 531,
	"./widgets/HorizontalLineWidget": 532,
	"./widgets/HorizontalLineWidget.jsx": 532,
	"./widgets/ImageMapWidget": 533,
	"./widgets/ImageMapWidget.jsx": 533,
	"./widgets/ImageMapWidget.module.scss": 336,
	"./widgets/ItemListWidget": 534,
	"./widgets/ItemListWidget.jsx": 534,
	"./widgets/ItemListWidget.module.scss": 409,
	"./widgets/JsonWidget": 535,
	"./widgets/JsonWidget.jsx": 535,
	"./widgets/JsonWidget.module.scss": 454,
	"./widgets/LabelWidget": 536,
	"./widgets/LabelWidget.jsx": 536,
	"./widgets/MLStringWidget": 537,
	"./widgets/MLStringWidget.jsx": 537,
	"./widgets/MissingWidget": 538,
	"./widgets/MissingWidget.jsx": 538,
	"./widgets/MultiInstanceNavigationWidget": 539,
	"./widgets/MultiInstanceNavigationWidget.jsx": 539,
	"./widgets/MultiInstanceNavigationWidget.module.scss": 455,
	"./widgets/NumberWidget": 540,
	"./widgets/NumberWidget.jsx": 540,
	"./widgets/NumberWidget.module.scss": 337,
	"./widgets/PasswordWidget": 541,
	"./widgets/PasswordWidget.jsx": 541,
	"./widgets/PictureWidget": 542,
	"./widgets/PictureWidget.jsx": 542,
	"./widgets/PictureWidget.module.scss": 303,
	"./widgets/RadiogroupWidget": 543,
	"./widgets/RadiogroupWidget.jsx": 543,
	"./widgets/RadiogroupWidget.module.scss": 456,
	"./widgets/ReadonlyStringWidget": 544,
	"./widgets/ReadonlyStringWidget.jsx": 544,
	"./widgets/RichTextWidget": 545,
	"./widgets/RichTextWidget.jsx": 545,
	"./widgets/RichTextWidget.module.scss": 457,
	"./widgets/SimpleDMSWidget": 546,
	"./widgets/SimpleDMSWidget.jsx": 546,
	"./widgets/SimpleDMSWidget.module.scss": 458,
	"./widgets/SliderWidget": 547,
	"./widgets/SliderWidget.jsx": 547,
	"./widgets/SplitWidget": 548,
	"./widgets/SplitWidget.jsx": 548,
	"./widgets/SplitWidget.module.scss": 268,
	"./widgets/StringListWidget": 550,
	"./widgets/StringListWidget.jsx": 550,
	"./widgets/StringListWidget.module.scss": 410,
	"./widgets/StringWidget": 131,
	"./widgets/StringWidget.jsx": 131,
	"./widgets/StringWidget.module.scss": 228,
	"./widgets/SurveyJsPlayerWidget": 551,
	"./widgets/SurveyJsPlayerWidget.jsx": 551,
	"./widgets/SurveyJsPlayerWidget.module.scss": 459,
	"./widgets/SwitchWidget": 552,
	"./widgets/SwitchWidget.jsx": 552,
	"./widgets/TabWidget": 553,
	"./widgets/TabWidget.jsx": 553,
	"./widgets/TabWidget.module.scss": 269,
	"./widgets/TableWidget": 554,
	"./widgets/TableWidget.jsx": 554,
	"./widgets/TableWidget.module.scss": 411,
	"./widgets/TagBoxWidget": 555,
	"./widgets/TagBoxWidget.jsx": 555,
	"./widgets/TagBoxWidget.module.scss": 338,
	"./widgets/TimeOverviewWidget": 556,
	"./widgets/TimeOverviewWidget.jsx": 556,
	"./widgets/TimeOverviewWidget.module.scss": 304,
	"./widgets/TimeWidget": 557,
	"./widgets/TimeWidget.jsx": 557,
	"./widgets/TimeWidget.module.scss": 460,
	"./widgets/ToolbarWidget": 558,
	"./widgets/ToolbarWidget.jsx": 558,
	"./widgets/ToolbarWidget.module.scss": 461,
	"./widgets/TranslatedTextWidget": 559,
	"./widgets/TranslatedTextWidget.jsx": 559,
	"./widgets/URLWidget": 560,
	"./widgets/URLWidget.jsx": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;